module.exports = __webpack_public_path__ + "img/856-52fb77.png";